import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPoint(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.3 8.787a.5.5 0 0 0-.5.5v7.45a.751.751 0 1 0 1.504 0v-2.16h1.74c.857 0 1.592-.294 2.113-.806.522-.514.824-1.24.824-2.095 0-.85-.296-1.574-.81-2.085-.512-.511-1.237-.804-2.085-.804zm1.004 4.5v-3.204h1.434c.557 0 .983.15 1.268.417s.443.663.443 1.182-.158.917-.444 1.185c-.286.27-.713.42-1.273.42z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.127c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75-4.365-9.75-9.75-9.75m-8.25 9.75a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }));
}
var IcPoint = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPoint));

export { IcPoint as I };
